import { useState } from "react";
import axios from "axios";
import { useAuth, useClerk } from "@clerk/react";
import { Loader2 } from "lucide-react";
import { API, errMsg } from "@/lib/api";
import { t } from "@/i18n";

const PICKS = [
  { role: "Junior Cashier", name: "Patrick", img: "/avatars/patrick.png", hint: "Sees register, coupons and drawer SOPs", testid: "guest-pick-junior-cashier" },
  { role: "Junior Cook", name: "Plankton", img: "/avatars/plankton.png", hint: "Sees recipes and kitchen SOPs", testid: "guest-pick-junior-cook" },
];

export function GuestPicker({ slug }) {
  const [busy, setBusy] = useState("");
  const [err, setErr] = useState("");
  const { isSignedIn } = useAuth();
  const { signOut } = useClerk();
  const go = async (role) => {
    setBusy(role); setErr("");
    try {
      const { data } = await axios.post(`${API}/public/guest/${slug}`, { role });
      if (isSignedIn) await signOut();
      sessionStorage.setItem("smboi-org", data.org_id);
      window.location.assign(`/sign-in?__clerk_ticket=${encodeURIComponent(data.ticket)}&redirect_url=${encodeURIComponent("/chat?welcome=1")}`);
    } catch (e) { setErr(errMsg(e)); setBusy(""); }
  };
  return (
    <div className="card stack-sm w-full max-w-lg" data-testid="guest-picker">
      <p className="font-semibold">{t("Try it without signing up")}</p>
      <p className="text-sm faint -mt-1">{t("Pick a job. You'll get your own practice copy for 24 hours.")}</p>
      <div className="grid sm:grid-cols-2 gap-3 mt-1">
        {PICKS.map((p) => (
          <button key={p.role} disabled={!!busy} onClick={() => go(p.role)} data-testid={p.testid}
            className="group flex items-center gap-3 text-left rounded-2xl border border-[var(--border-color)] p-3 transition-[transform,background-color,border-color] hover:-translate-y-0.5 hover:border-[#f97316] hover:bg-[var(--bg-surface-hover)] disabled:opacity-60">
            <img src={p.img} alt={p.name} className="h-14 w-14 rounded-full object-cover shrink-0 ring-2 ring-[#f97316]/40 group-hover:ring-[#f97316]" />
            <span className="min-w-0">
              <span className="block font-semibold">{t(p.role)}</span>
              <span className="block text-xs faint">{t(`as ${p.name}`)}</span>
              <span className="block text-xs muted mt-0.5">{t(p.hint)}</span>
            </span>
            {busy === p.role && <Loader2 size={16} className="animate-spin ml-auto shrink-0" />}
          </button>
        ))}
      </div>
      {err && <p className="text-sm text-[var(--status-error)]" data-testid="guest-error">{err}</p>}
    </div>
  );
}
